import { render, staticRenderFns } from "./KlarnaModal.vue?vue&type=template&id=7ea50302&scoped=true"
import script from "./KlarnaModal.vue?vue&type=script&lang=js"
export * from "./KlarnaModal.vue?vue&type=script&lang=js"
import style0 from "./KlarnaModal.vue?vue&type=style&index=0&id=7ea50302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea50302",
  null
  
)

export default component.exports